'use strict';

import 'components/dropdown-menu';
import './component.scss';
import './logo.png';
import './logo-h.png';
import './logo-m.png';
import './logo-oss.svg';
import './logo-version.png';

function isHeadless() {
    const headless = sessionStorage.getItem('headless');
    const acceptJavaScript = sessionStorage.getItem('acceptJavaScript');
    const openApiFeatureEnabled = sessionStorage.getItem('openApiFeatureEnabled');

    const header = document.querySelector('.page-header-container');
    if (header !== null) {
        if (headless === 'true' && acceptJavaScript === 'true' && openApiFeatureEnabled === 'true') {
         header.style.display='none';
        }
    }
}
window.addEventListener('DOMContentLoaded', isHeadless);
